module.exports = __webpack_public_path__ + "HelveticaNeueLTStdBd.197a2188979f81085c23.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/HelveticaNeueLTStdBd.eot
// module id = ../../../../../src/assets/fonts/HelveticaNeueLTStdBd.eot
// module chunks = styles